import React from "react";
import { Link } from "react-router-dom";
const ThreeBlogs = () => {
  return (
    <div class="font-sans max-w-6xl mx-auto p-4 mt-20 cursor-default">
      <div class="mb-10">
        <Link to="/blogs/first-blog" className="block">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-bold font-serif">Ramdan</h2>
            <span class="text-pink-500 text-sm hover:underline">See all</span>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* <!-- Card 1 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://images.unsplash.com/photo-1527842891421-42eec6e703ea?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fG5pZ2h0JTIwc2t5JTIwbW9vbnxlbnwwfHwwfHx8MA%3D%3D"
                alt="Muslim man working"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div class="absolute top-0 right-0 bg-pink-500 text-white p-2 text-sm">
                <div>Made by Muslims</div>
                <div>For Muslims</div>
              </div>
              <div class="absolute bottom-8 left-0 bg-white bg-opacity-75 p-1">
                {/* <p class="text-sm font-bold">
                  10 Years In, Here's What Happened
                </p> */}
              </div>
              <h3 class="font-serif font-bold mt-3 hover:text-[#730000]">
                Still Muslim-owned. This is what it looks like when you don't
                fold...
              </h3>
              <p class="text-xs mt-1">
                Three lawsuits. One name lost. Ten million members later, we're
                still here. Three acquisition offers. Three lawsuits.
              </p>
            </div>

            {/* <!-- Card 2 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://plus.unsplash.com/premium_photo-1677966145676-8641eb66b942?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Pink billboard"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                Did Mohamed Ever Find a Wife? The Inside Scoop of SelectProposal
                Most Viral Campaig
              </h3>
              <p class="text-xs mt-1">
                "Mohamed, that's you??" At this point, everyone has seen the
                huge pink billboards.
              </p>
            </div>

            {/* <!-- Card 3 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJs1bb8HttfWaE9yXn58_2aamN40gt4PRj5g&s"
                alt="Moon crescent"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                When is Laylatul Qadr in 2025?
              </h3>
              <p class="text-xs mt-1">
                We're already halfway through Ramadan, and we're about to enter
                the most holiest night in Islam. The last ten nights of Ramadan
                are extra special, especially the odd ones, as this is when...
              </p>
            </div>
          </div>
        </Link>
      </div>

      {/* <!-- Community Section --> */}

      <div class="mb-10">
        <Link to="/blogs/second-blog">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-bold font-serif">Community</h2>
            <span class="text-pink-500 text-sm hover:underline">See all</span>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* <!-- Card 1 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3oBlct21G6_iyHETI0VG33H9sCbbGhUge5Q&s"
                alt="Moon crescent"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                When is Laylatul Qadr in 2025?
              </h3>
              <p class="text-xs mt-1">
                We're already halfway through Ramadan, and we're about to enter
                the most holiest night in Islam. The last ten nights of Ramadan
                are extra special, especially the odd ones, as this is when...
              </p>
            </div>

            {/* <!-- Card 2 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrwUa5tDPo-5UloVBc5X7ile4aoQTHh0W6lw&s"
                alt="Times Square crowd"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div class="absolute top-0 right-0 bg-pink-500 text-white p-2 text-sm">
                <div>OUR COMMUNITY HELP PALESTENIANS</div>
              </div>
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                3,000 Muslims Took Over Times Square for Taraweeh
              </h3>
              <p class="text-xs mt-1">
                Thousands gathered under the bright lights of NYC Times Square
                for a historic Taraweeh prayer. From viral billboards to a
                surprise spiritual twist: how we took over NYC for Ramadan
                iftarion...
              </p>
            </div>

            {/* <!-- Card 3 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://images.theconversation.com/files/455174/original/file-20220330-6091-i4h5l2.jpg?ixlib=rb-4.1.0&q=20&auto=format&w=320&fit=clip&dpr=2&usm=12&cs=strip"
                alt="Muslim women talking"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                The Rise of 'Judgement' During Ramadan: Unpacking 'Ramadan
                Muslims'
              </h3>
              <p class="text-xs mt-1">
                We need to talk: why do we look out for in relationships or
                friendships, but what about Ramadan and flags to look out for?
                In this time of year often brings a lot of judgment from Muslims
                who claim...
              </p>
            </div>
          </div>
        </Link>
      </div>

      {/* <!-- SelectProposal Section --> */}
      <div class="mb-10">
        <Link to="/blogs/third-blog">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-bold font-serif">SelectProposal</h2>
            <a href="#" class="text-pink-500 text-sm hover:underline">
              See all
            </a>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* <!-- Card 1 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://images.unsplash.com/photo-1527842891421-42eec6e703ea?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fG5pZ2h0JTIwc2t5JTIwbW9vbnxlbnwwfHwwfHx8MA%3D%3D"
                alt="Business proposal"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                Master the Art of Proposal Writing
              </h3>
              <p class="text-xs mt-1">
                Learn the key strategies to craft compelling business proposals
                that stand out from the competition and win more clients.
              </p>
            </div>

            {/* <!-- Card 2 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrwUa5tDPo-5UloVBc5X7ile4aoQTHh0W6lw&s"
                alt="AI technology concept"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                How AI is Transforming Proposal Development
              </h3>
              <p class="text-xs mt-1">
                Discover how SelectProposal's AI-powered tools are helping
                businesses create winning proposals in less time with greater
                accuracy.
              </p>
            </div>

            {/* <!-- Card 3 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcZdengGsiEcXWajdsUEoct_8eocP4xwwS9Q&s"
                alt="Success concept"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                Client Success Story: From Startup to Industry Leader
              </h3>
              <p class="text-xs mt-1">
                See how one of our clients used SelectProposal to secure major
                contracts and grow their business exponentially in just 18
                months.
              </p>
            </div>
          </div>
        </Link>
      </div>

      {/* <!-- Business Strategy Section --> */}
      <div class="mb-10">
        <Link to="/blogs/fourth-blog">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-bold font-serif">Business Strategy</h2>
            <span class="text-pink-500 text-sm hover:underline">See all</span>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* <!-- Card 1 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://www.uptonbarn.com/wp-content/uploads/2024/07/Lucy-and-Yousef-High-Resolution-832-of-1006-scaled.jpg"
                alt="Business meeting"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                5 Ways to Improve Your Pitch Meetings
              </h3>
              <p class="text-xs mt-1">
                Master the art of the pitch meeting with these proven techniques
                that will help you convert prospects into clients with
                confidence.
              </p>
            </div>

            {/* <!-- Card 2 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://images.theconversation.com/files/455174/original/file-20220330-6091-i4h5l2.jpg?ixlib=rb-4.1.0&q=20&auto=format&w=320&fit=clip&dpr=2&usm=12&cs=strip"
                alt="Calendar planning"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                Proposal Planning: The 30-60-90 Day Strategy
              </h3>
              <p class="text-xs mt-1">
                Learn how to create a strategic proposal development timeline
                that ensures quality, consistency, and higher win rates.
              </p>
            </div>

            {/* <!-- Card 3 --> */}
            <div class="relative border-b-4 border-red-600 rounded-bl-md rounded-br-md">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSq4447GYAE6Wl-B9lmDr7Z-GjFVWXQt7HGaw&s"
                alt="Growth chart"
                class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
              <h3 class="font-serif font-bold mt-2 hover:text-[#730000]">
                Scaling Your Proposal Team: When and How
              </h3>
              <p class="text-xs mt-1">
                Discover the key indicators that it's time to expand your
                proposal team and the best practices for scaling without
                sacrificing quality.
              </p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ThreeBlogs;
